module.exports = __webpack_public_path__ + "img/02.23521b33.jpg";